import { Block } from '@chameleoncreator/creator-app';

export enum TrackerState {
  DIRTY,
  CLEAN,
  DELETED,
}

export interface Tracker {
  [key: string]: TrackerState;
}

interface Timing {
  firstLoad: number;
  complete: number;
  buttonClick: { [key: string]: number };
}

export interface Report {
  key?: number;
  id: string;
  question?: string | undefined;
  reportable: 'multichoice' | 'sortation';
  type: string;
  response: string;
  result: 0 | 1;
}

export interface AssessmentData {
  scoring: boolean;
  score: number;
}

export interface QuestionData {
  id: string;
  questionName: string;
  answer: string[];
  correctAnswer: string[];
  isCorrect: boolean | undefined;
  attemptCount: string | number;
  navigateToResults: boolean;
  isLocked: boolean;
  submitButtonLabel: string;
}

export interface Question {
  [key: string]: QuestionData;
  // {
  //   id: string;
  //   questionName: string;
  //   answer: string[];
  //   correctAnswer: string[];
  //   isCorrect: boolean | undefined;
  //   attemptCount: number;
  // };
}

export interface Assessment {
  [key: string]: {
    data?: AssessmentData;
    results?: {
      [key: string]: Question;
    };
  };
}

export interface Assessments {
  // 'data':{
  //   [key: string]: string | number;
  // };
  // [key: string]: Question;
  [key: string]: Assessment;
}

export interface NextState {
  apiError: { count: number; err: any };
  blocks: { [key: string]: Block };
  bookmarkLoaded: boolean;
  bookmarkLocation: string | undefined;
  currentInteraction?: string;
  currentInteractionBlockId?: string | null;
  currentTopic?: string;
  customFonts: any[];
  error: any;
  exit: boolean;
  exitComplete: boolean;
  feedback: {
    [key: string]: {
      key: string;
      rating: number;
      message: string;
      identity: string;
      reference: string;
    };
  };
  focusedNodeId?: string;
  hasError: boolean;
  hideHeader: boolean;
  interactionsLocked: string[];
  interactionsOpen: string[];
  interactionsSeen: string[];
  isScrolling: boolean;
  lastFocusedNodeId?: string;
  links: any;
  mirrorActive: boolean;
  nextInteractionMap: { [key: string]: string };
  projectId?: string;
  rootBlockId: string | undefined;
  scormSettings: {
    passMark: number;
    setCompleteFromScore: boolean;
    setCompleteOnExit: boolean;
    setCompleteWhenAllPagesViewed: boolean;
  };
  theme: {
    backgroundColor: string;
    buttonBackgroundColor: string;
    buttonBorderRadius: number;
    buttonOutline: boolean;
    buttonShadow: boolean;
    buttonShape: string;
    buttonTextColor: string;
    fontFamilies: any[];
    fontFamily: string;
    headerBackgroundColor: string;
    headerTextColor: string;
    highContrast: boolean;
    progressBar: boolean;
    recoloredChameleonImages: any;
    textColor: string;
    topicMenu: boolean;
    useImagePreloader: boolean;
    userPalette: any[];
  };
  themeId?: string;
  tracker: Tracker;
  userBehaviour: {
    interactionTiming: { [key: string]: Timing };
    score: { [key: string]: 0 | 1 };
    scormResponses: {
      [key: string]: Report;
    };
  };
  assessments: Assessments;
}

export type State = NextState;

export type Action = { type: string; data: { [key: string]: any } };

export const initialState: NextState = {
  apiError: { count: 0, err: undefined },
  blocks: {},
  bookmarkLoaded: false,
  bookmarkLocation: undefined,
  currentInteraction: undefined,
  currentInteractionBlockId: undefined,
  currentTopic: undefined,
  customFonts: [],
  error: undefined,
  exit: false,
  exitComplete: false,
  focusedNodeId: undefined,
  feedback: {},
  hasError: false,
  hideHeader: false,
  interactionsLocked: [],
  interactionsOpen: [],
  interactionsSeen: [],
  isScrolling: false,
  lastFocusedNodeId: undefined,
  links: {},
  mirrorActive: false,
  nextInteractionMap: {},
  projectId: undefined,
  rootBlockId: undefined,
  scormSettings: {
    passMark: 80,
    setCompleteFromScore: false,
    setCompleteOnExit: false,
    setCompleteWhenAllPagesViewed: true,
  },
  theme: {
    backgroundColor: '#fff',
    buttonBackgroundColor: '#060709',
    buttonBorderRadius: 0,
    buttonOutline: false,
    buttonShadow: false,
    buttonShape: 'pill',
    buttonTextColor: '#fff',
    fontFamilies: [],
    fontFamily: '',
    headerBackgroundColor: '#fff',
    headerTextColor: '#060709',
    highContrast: false,
    progressBar: true,
    recoloredChameleonImages: {},
    textColor: '#060709',
    topicMenu: true,
    useImagePreloader: true,
    userPalette: [],
  },
  themeId: undefined,
  tracker: {},
  userBehaviour: {
    score: {},
    interactionTiming: {},
    scormResponses: {},
  },
  assessments: {},
};
